module.exports = __webpack_public_path__ + "img/ticon2.31b7fb89.png";